import type { Error } from '../types';
import { CONTAIN_UPPERCASE_LETTER_REGEXP } from '../utils/regex';

export const mustContainUpperCaseLetter =
  (message?: Error['message']) =>
  (value: string): Error => ({
    valid: !!value && CONTAIN_UPPERCASE_LETTER_REGEXP.test(value),
    message
  });
